import angular from 'angular'

import template from '../../../templates/current-sale/wr-quick-keys.html'

/**
 * Directive for rendering the quick keys for the active register.
 *
 * @module webregister.directives.wrQuickKeys
 */
angular.module('webregister.directives').directive('wrQuickKeys', function () {
  return {
    restrict: 'E',
    template,
    controllerAs: 'wrQuickKeysCtrl',
    controller: 'wrQuickKeysCtrl',
  }
})
